/*
 * Ryan O'Dowd
 * 2025-05-21
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import HeaderIcon from '@components/Header/HeaderIcon';
import React from 'react';
import hooks from '@hooks';

const BackIcon = (props: BackIconProps) => {
  const navigation = hooks.useNavigation();

  return (
    <HeaderIcon
      icon='arrow-left'
      onPress={() => navigation.goBack()}
      {...props}
    />
  );
};

class BackIconProps {
  icon?: string | React.ReactNode;
  onPress?: () => void;
  hideIcon?: boolean;
  hasBadge?: boolean;
};

export default BackIcon;
